import { render, staticRenderFns } from "./fichaje-form.vue?vue&type=template&id=024a27c2&scoped=true"
import script from "./fichaje-form.vue?vue&type=script&lang=js"
export * from "./fichaje-form.vue?vue&type=script&lang=js"
import style0 from "./fichaje-form.vue?vue&type=style&index=0&id=024a27c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024a27c2",
  null
  
)

export default component.exports